import { render, staticRenderFns } from "./message_shortcut_button.vue?vue&type=template&id=d04f93ca&"
import script from "./message_shortcut_button.vue?vue&type=script&lang=js&"
export * from "./message_shortcut_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports